// Firebase configuration
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// XRPL Configuration
export const xrplConfig = {
  network: import.meta.env.VITE_XRPL_NETWORK || 'testnet',
  nutsIssuer: import.meta.env.VITE_NUTS_ISSUER_ADDRESS,
  nutsCurrency: import.meta.env.VITE_NUTS_CURRENCY_CODE || 'NUTS',
  entryFee: import.meta.env.VITE_ENTRY_FEE_AMOUNT || '1000', // NBA entry fee: 1000 $NUTS
  xummApiKey: import.meta.env.VITE_XUMM_API_KEY,
};

// App Configuration
export const appConfig = {
  adminPassword: import.meta.env.VITE_ADMIN_PASSWORD,
  baseUrl: import.meta.env.VITE_BASE_URL || 'http://localhost:5173',
  functionsUrl: import.meta.env.VITE_FUNCTIONS_URL || 'http://localhost:5001',
};
